import {
  CustomFilterConfig,
  DateQuery,
  FirmaCustomFilter,
  KursusCustomFilter,
  NumberQuery,
  PersonCustomFilter,
  StringQuery,
} from "../../components/filter/custom/types";
import {
  FakturaAfsendelseId,
  KlienterklaeringStatusId,
  KlienterklaeringstypeId,
  TilsynserklaeringStatusId,
} from "../../interfaces/schema";

export const stringQueries: StringQuery[] = [
  {
    query: "contains",
    displayName: "Indeholder",
  },
  {
    query: "eq",
    displayName: "Lig med",
  },
  {
    query: "startsWith",
    displayName: "Starter med",
  },
];

export const numberQueries: NumberQuery[] = [
  {
    query: "eq",
    displayName: "Lig med",
  },
  {
    query: "lt",
    displayName: "Mindre end",
  },
  {
    query: "gt",
    displayName: "Større end",
  },
];

export const dateQueries: DateQuery[] = [
  {
    query: "eq",
    displayName: "Lig med",
  },
  {
    query: "lt",
    displayName: "Før",
  },
  {
    query: "gt",
    displayName: "Efter",
  },
];

export const PersonCustomFilterConfig: CustomFilterConfig<PersonCustomFilter>[] =
  [
    {
      id: "fornavne",
      queryKey: "fornavne",
      displayName: "Fornavn(e)",
      category: "Felt",
      dataType: "string",
      component: {
        type: "input",
        values: undefined,
      },
    },
    {
      id: "efternavn",
      queryKey: "efternavn",
      displayName: "Efternavn",
      category: "Felt",
      dataType: "string",
      component: {
        type: "input",
        values: undefined,
      },
    },
    {
      id: "kundeNr",
      queryKey: "kundeNr",
      displayName: "Kundenummer",
      category: "Felt",
      dataType: "number",
      component: {
        type: "input",
        values: undefined,
      },
    },
    {
      id: "foedselsDato",
      queryKey: "foedselsDato",
      displayName: "Fødselsdato",
      category: "Felt",
      dataType: "string",
      component: {
        type: "date",
        values: undefined,
      },
    },
    {
      id: "koen",
      queryKey: "koen",
      displayName: "Køn",
      category: "Felt",
      dataType: "string",
      component: {
        type: "select",
        values: [
          {
            value: "K",
            displayName: "Kvinde",
          },
          {
            value: "M",
            displayName: "Mand",
          },
        ],
      },
    },
    {
      id: "personKlienterklaering",
      queryKey: "personKlienterklaering",
      displayName: "Klienterklæring",
      category: "Relation",
      dataType: "object",
      component: {
        type: "nested",
        values: [
          {
            id: "erklAar",
            queryKey: "erklAar",
            displayName: "Erklæringår",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "erklNr",
            queryKey: "erklNr",
            displayName: "Erklæringnummer",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "klienterklaeringstype",
            queryKey: "klienterklaeringstype",
            displayName: "Klienterklæringstype",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  value: KlienterklaeringstypeId.LoebendeErklaering,
                  displayName: "Løbende erklæring",
                },
                {
                  value: KlienterklaeringstypeId.SlutErklaering,
                  displayName: "Slut erklæring",
                },
              ],
            },
          },
          {
            id: "erklModtaget",
            queryKey: "erklModtaget",
            displayName: "Erklæring modtaget dato",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
          {
            id: "erklModtagetNull",
            queryKey: "erklModtaget",
            displayName: "Erklæring modtaget dato (ingen værdi)",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  displayName: "Uden modtaget dato",
                  value: "null",
                },
              ],
            },
          },
          {
            id: "frist",
            queryKey: "frist",
            displayName: "Frist",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
          {
            id: "klienterklaeringStatus",
            queryKey: "klienterklaeringStatus",
            displayName: "Status",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  value: KlienterklaeringStatusId.FristOrdinaer,
                  displayName: "Frist ordinær",
                },
                {
                  value: KlienterklaeringStatusId.IndbragtForAdvokatnaevnet,
                  displayName: "Indbragt for Advokatnævnet",
                },
                {
                  value: KlienterklaeringStatusId.ModtagetMedFejl,
                  displayName: "Modtaget med fejl",
                },
                {
                  value: KlienterklaeringStatusId.ModtagetUdenFejl,
                  displayName: "Modtaget uden fejl",
                },
                {
                  value: KlienterklaeringStatusId.Revisor,
                  displayName: "Revisor",
                },
                {
                  value: KlienterklaeringStatusId.Undersoeges,
                  displayName: "Undersøges",
                },
              ],
            },
          },
          {
            id: "erklNrWeb",
            queryKey: "erklNrWeb",
            displayName: "Erklæringnummer web",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "firmaCvrNr",
            queryKey: "firmaCvrNr",
            displayName: "Firma CVR-nummer",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "firmaCvrNrNull",
            queryKey: "firmaCvrNr",
            displayName: "Firma CVR-nummer (ingen værdi)",
            category: "Felt",
            dataType: "number",
            component: {
              type: "checkbox",
              values: [
                {
                  displayName: "Uden CVR-nummer",
                  value: "null",
                },
              ],
            },
          },
          {
            id: "periode",
            queryKey: "periode",
            displayName: "Periode",
            category: "Felt",
            dataType: "object",
            component: {
              type: "period",
              values: undefined,
            },
          },
        ],
      },
    },
    {
      id: "personTilsynserklaering",
      queryKey: "personTilsynserklaering",
      displayName: "Tilsynserklæring",
      category: "Relation",
      dataType: "object",
      component: {
        type: "nested",
        values: [
          {
            id: "erklAar",
            queryKey: "erklAar",
            displayName: "Erklæringsår",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "erklModtaget",
            queryKey: "erklModtaget",
            displayName: "Erklæring modtaget",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
          {
            id: "tilsynserklaeringStatus",
            queryKey: "tilsynserklaeringStatus",
            displayName: "Status",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  value: TilsynserklaeringStatusId.FristOrdinaer,
                  displayName: "Frist ordinær",
                },
                {
                  value: TilsynserklaeringStatusId.IndbragtForAdvokatnaevnet,
                  displayName: "Indbragt for Advokatnævnet",
                },
                {
                  value: TilsynserklaeringStatusId.ModtagetMedFejl,
                  displayName: "Modtaget med fejl",
                },
                {
                  value: TilsynserklaeringStatusId.ModtagetUdenFejl,
                  displayName: "Modtaget uden fejl",
                },
                {
                  value: TilsynserklaeringStatusId.Undersoeges,
                  displayName: "Undersøges",
                },
              ],
            },
          },
          {
            id: "koerselDato",
            queryKey: "koerselDato",
            displayName: "Kørselsdato",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
        ],
      },
    },
    {
      id: "fmuretssagsproeveEksaminand",
      queryKey: "fmuretssagsproeveEksaminand",
      displayName: "Retssagsprøver",
      category: "Relation",
      dataType: "object",
      component: {
        type: "nested",
        values: [
          {
            id: "nr",
            queryKey: "nr",
            displayName: "Nummer",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "fiktiv",
            queryKey: "fiktiv",
            displayName: "Fiktiv",
            dataType: "boolean",
            category: "Felt",
            component: {
              type: "select",
              values: [
                {
                  displayName: "Ja",
                  value: "true",
                },
                {
                  displayName: "Nej",
                  value: "false",
                },
              ],
            },
          },
          {
            id: "proceduredato",
            queryKey: "proceduredato",
            displayName: "Procedure dato",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
        ],
      },
    },
    {
      id: "personAbonnement",
      queryKey: "personAbonnement",
      displayName: "Abonnement",
      category: "Relation",
      dataType: "object",
      component: {
        type: "nested",
        values: [
          {
            id: "faktureres",
            queryKey: "faktureres",
            displayName: "Faktureres",
            category: "Felt",
            dataType: "boolean",
            component: {
              type: "select",
              values: [
                {
                  displayName: "Ja",
                  value: "true",
                },
                {
                  displayName: "Nej",
                  value: "false",
                },
              ],
            },
          },
          {
            id: "periode",
            queryKey: "periode",
            displayName: "Periode",
            category: "Felt",
            dataType: "object",
            component: {
              type: "period",
              values: undefined,
            },
          },
          {
            id: "antalEksemplar",
            queryKey: "antalEksemplar",
            displayName: "Antal",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "abonnementNr",
            queryKey: "abonnementNr",
            displayName: "Abonnement",
            category: "Felt",
            dataType: "number",
            component: {
              type: "checkbox",
              values: [
                {
                  displayName: "Ja",
                  value: "1",
                },
              ],
            },
          },
        ],
      },
    },
  ];

export const FirmaCustomFilterConfig: CustomFilterConfig<FirmaCustomFilter>[] =
  [
    {
      id: "navn1",
      queryKey: "navn1",
      displayName: "Navn",
      category: "Felt",
      dataType: "string",
      component: {
        type: "input",
        values: undefined,
      },
    },
    {
      id: "firmaKlienterklaering",
      queryKey: "firmaKlienterklaering",
      displayName: "Klienterklæring",
      category: "Relation",
      dataType: "object",
      component: {
        type: "nested",
        values: [
          {
            id: "erklAar",
            queryKey: "erklAar",
            displayName: "Erklæringår",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "erklNr",
            queryKey: "erklNr",
            displayName: "Erklæringnummer",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "klienterklaeringstype",
            queryKey: "klienterklaeringstype",
            displayName: "Klienterklæringstype",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  value: KlienterklaeringstypeId.LoebendeErklaering,
                  displayName: "Løbende erklæring",
                },
                {
                  value: KlienterklaeringstypeId.SlutErklaering,
                  displayName: "Slut erklæring",
                },
              ],
            },
          },
          {
            id: "erklModtaget",
            queryKey: "erklModtaget",
            displayName: "Erklæring modtaget",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
          {
            id: "erklModtagetNull",
            queryKey: "erklModtaget",
            displayName: "Erklæring modtaget dato (ingen værdi)",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  displayName: "Uden modtaget dato",
                  value: "null",
                },
              ],
            },
          },
          {
            id: "frist",
            queryKey: "frist",
            displayName: "Frist",
            category: "Felt",
            dataType: "string",
            component: {
              type: "date",
              values: undefined,
            },
          },
          {
            id: "klienterklaeringStatus",
            queryKey: "klienterklaeringStatus",
            displayName: "Status",
            category: "Felt",
            dataType: "string",
            component: {
              type: "checkbox",
              values: [
                {
                  value: KlienterklaeringStatusId.FristOrdinaer,
                  displayName: "Frist ordinær",
                },
                {
                  value: KlienterklaeringStatusId.IndbragtForAdvokatnaevnet,
                  displayName: "Indbragt for Advokatnævnet",
                },
                {
                  value: KlienterklaeringStatusId.ModtagetMedFejl,
                  displayName: "Modtaget med fejl",
                },
                {
                  value: KlienterklaeringStatusId.ModtagetUdenFejl,
                  displayName: "Modtaget uden fejl",
                },
                {
                  value: KlienterklaeringStatusId.Revisor,
                  displayName: "Revisor",
                },
                {
                  value: KlienterklaeringStatusId.Undersoeges,
                  displayName: "Undersøges",
                },
              ],
            },
          },
          {
            id: "erklNrWeb",
            queryKey: "erklNrWeb",
            displayName: "Erklæringnummer web",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "firmaCvrNr",
            queryKey: "firmaCvrNr",
            displayName: "Firma CVR-nummer",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
          {
            id: "firmaCvrNrNull",
            queryKey: "firmaCvrNr",
            displayName: "Firma CVR-nummer (ingen værdi)",
            category: "Felt",
            dataType: "number",
            component: {
              type: "checkbox",
              values: [
                {
                  displayName: "Uden CVR-nummer",
                  value: "null",
                },
              ],
            },
          },
          {
            id: "periode",
            queryKey: "periode",
            displayName: "Periode",
            category: "Felt",
            dataType: "object",
            component: {
              type: "period",
              values: undefined,
            },
          },
        ],
      },
    },
    {
      id: "ean",
      queryKey: "ean",
      displayName: "EAN-nr.",
      category: "Felt",
      dataType: "string",
      component: {
        type: "input",
        values: undefined,
      },
    },
    {
      id: "fakturaAfsendelse",
      queryKey: "fakturaAfsendelse",
      displayName: "Faktura afsend standard",
      category: "Felt",
      dataType: "string",
      component: {
        type: "checkbox",
        values: [
          {
            value: FakturaAfsendelseId.Brev,
            displayName: "Brev",
          },
          {
            value: FakturaAfsendelseId.Ean,
            displayName: "EAN",
          },
          {
            value: FakturaAfsendelseId.Eboks,
            displayName: "E-Boks",
          },
          {
            value: FakturaAfsendelseId.Email,
            displayName: "Email",
          },
        ],
      },
    },
    {
      id: "firma-periode",
      queryKey: "periode",
      category: "Felt",
      dataType: "object",
      displayName: "Periode",
      component: {
        type: "period",
        values: undefined,
      },
    },
    {
      id: "firmaAbonnement",
      queryKey: "firmaAbonnement",
      displayName: "Abonnement",
      category: "Relation",
      dataType: "object",
      component: {
        type: "nested",
        values: [
          {
            id: "faktureres",
            queryKey: "faktureres",
            displayName: "Faktureres",
            category: "Felt",
            dataType: "boolean",
            component: {
              type: "select",
              values: [
                {
                  displayName: "Ja",
                  value: "true",
                },
                {
                  displayName: "Nej",
                  value: "false",
                },
              ],
            },
          },
          {
            id: "periode",
            queryKey: "periode",
            displayName: "Periode",
            category: "Felt",
            dataType: "object",
            component: {
              type: "period",
              values: undefined,
            },
          },
          {
            id: "antalEksemplar",
            queryKey: "antalEksemplar",
            displayName: "Antal",
            category: "Felt",
            dataType: "number",
            component: {
              type: "input",
              values: undefined,
            },
          },
        ],
      },
    },
  ];

export const KursusCustomFilterConfig: CustomFilterConfig<KursusCustomFilter>[] =
  [
    {
      id: "navn",
      queryKey: "navn",
      displayName: "Navn",
      category: "Felt",
      dataType: "string",
      component: {
        type: "input",
        values: undefined,
      },
    },
    // {
    //   id: "fraDato",
    //   queryKey: "fraDato",
    //   displayName: "Startdato",
    //   category: "Felt",
    //   dataType: "string",
    //   component: {
    //     type: "date",
    //     values: undefined,
    //   },
    // },
  ];
